export class AdapterCache {
  constructor() {
    this._cache = {};
  }
  set(key, data) {
    this._cache[key] = data;
  }
  get(key) {
    return this._cache[key];
  }
  clear(key) {
    delete this._cache[key];
  }
  clearAll() {
    this._cache = {};
  }
}